// Unpublished Work © 2020-2025 Deere & Company.

export function get<T>(key: string): T {
    return process.env[key] as any;
}
